/**
 * MONSTER TOWN — FURNITURE IDS. OWNED BY THE INTERIORS CREW.
 *
 * One place the ids are spelled, so the content defs, the starter layouts and
 * the harness demos can never drift apart. Ids are SAVE DATA — once shipped,
 * never rename one; add a new id instead.
 */

import type { PlaceableId } from '../core/types'

const id = (s: string): PlaceableId => s as PlaceableId

export const F = {
  // -- free forever (plain furniture: a kid is never stuck) ----------------
  bed: id('bed_cosy'),
  couch: id('furn_couch'),
  chair: id('furn_chair'),
  table: id('furn_table'),
  rug: id('decor_rug'),
  lampTable: id('light_lamp'),
  plant: id('decor_plant'),
  fridge: id('kitchen_fridge'),
  stove: id('kitchen_stove'),
  sink: id('kitchen_sink'),
  bath: id('bath_tub'),
  paintCan: id('decor_paint_can'),
  floorSample: id('decor_floor_sample'),
  /** The doorway mat. Flat, bright, tappable — the way out of every room. */
  exitMat: id('house_exit_mat'),

  // -- bought with coins (the fun stuff) ----------------------------------
  tv: id('appliance_tv'),
  bookshelf: id('furn_bookshelf'),
  toybox: id('toy_box'),
  poster: id('decor_poster'),
  clock: id('decor_clock'),
  lampFloor: id('light_floor_lamp'),
  fishTank: id('decor_fish_tank'),
  cake: id('decor_cake_stand'),
} as const

/** Plain furniture that must stay free forever even though it is not a block. */
export const FREE_FURNITURE_IDS: readonly PlaceableId[] = [
  F.bed,
  F.couch,
  F.chair,
  F.table,
  F.rug,
  F.lampTable,
  F.plant,
  F.fridge,
  F.stove,
  F.sink,
  F.bath,
  F.paintCan,
  F.floorSample,
  F.exitMat,
]
